"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("../../configuration");
exports.default = (0, configuration_1.ConfigurationSchema)('BaseConnection', {
    name: {
        type: 'string',
        defaultValue: 'nameOfConnection',
        description: 'a unique name for this connection',
    },
    assemblyNames: {
        type: 'stringArray',
        defaultValue: [],
        description: 'optional list of names of assemblies in this connection',
    },
}, { explicitlyTyped: true, explicitIdentifier: 'connectionId' });
